import { type SOCIAL_ITEM, SOCIAL_KEY } from '@src/constants/FJShareSocialConstant.ts';
import { useEffect, useRef, useState } from 'react';
import FJEvent from '@src/store/FJEvent';
import FJPublishManager from '@src/manager/publish/FJPublishManager.ts';
import FJUtil from '@src/util/FJUtil';
import FJMessageStore, { MESSAGE_TYPE } from '@src/store/FJMessageStore';
import styles from '@src/components/FJModals/FJShareModal/FJShareContent/FJCommon.module.less';
import FJAIGenerateButton from '@src/components/FJModals/FJShareModal/FJShareContent/FJAIGenerateButton.tsx';
import CopyIcon from '../../../../../assets/copy.svg?react';
import FJHeader from '@src/components/FJModals/FJShareModal/FJShareContent/FJHeader.tsx';
import FJLocalStore from '@src/store/FJLocalStore';
import FJExpansionInput from '@src/components/FJModals/FJShareModal/FJShareContent/FJExpansionInput.tsx';
import FJErrorTitle from '@src/components/FJModals/FJShareModal/FJShareContent/FJErrorTitle.tsx';
import FJAITextLoading from '@src/components/FJModals/FJShareModal/FJShareContent/FJAITextLoading.tsx';
import LinkedinIcon from '../../../../../assets/linkedin.svg?react';
import DefaultAvatarIcon from '../../../../../assets/profile.svg?react';
import FJToolTip from '@src/common/components/FJToolTip/FJToolTip';

interface Props {
    data: SOCIAL_ITEM;
    onCreateDescription?: () => void;
    defaultDescription?: string;
    isLoadingDescription?: boolean;
}

const FJLinkedinView = ({ data, onCreateDescription, defaultDescription, isLoadingDescription }: Props) => {
    const inputDescRef = useRef(null);
    const [isShowDescriptionCopy, setIsShowDescriptionCopy] = useState(true);
    const [isLackOfDescription, setIsLackOfDescription] = useState(false);

    useEffect(() => {
        setIsShowDescriptionCopy(!!defaultDescription);
    }, [defaultDescription]);

    useEffect(() => {
        FJEvent.subscribe('check options', () => {
            const target = FJPublishManager.getPublishTarget(SOCIAL_KEY.LINKEDIN);
            if (target && !target.description.trim()) {
                setIsLackOfDescription(true);
            }
        });
    }, []);

    const _copyDescription = () => {
        const text = inputDescRef.current.getValue();
        if (text) {
            FJUtil.copyTextToClipBoard(text);
            FJMessageStore.addMessage(FJLocalStore._('copy-successful'), MESSAGE_TYPE.SUCCESS);
        }
    };

    const _renderDescriptionGenerateButton = () => {
        return (
            <div className={styles.input_foot}>
                <FJAIGenerateButton onClick={onCreateDescription} />
                {isShowDescriptionCopy && (
                    <FJToolTip title={FJLocalStore._('copy')}>
                        <div className={styles.copy_btn} onClick={_copyDescription}>
                            <CopyIcon />
                        </div>
                    </FJToolTip>
                )}
            </div>
        );
    };

    const _descriptionChange = (value: string) => {
        const target = FJPublishManager.getPublishTarget(SOCIAL_KEY.LINKEDIN);
        if (target) {
            target.description = value;
            target.descriptionChanged = true;
        }
        setIsLackOfDescription(false);
        setIsShowDescriptionCopy(!!value);
    };

    const { avatar, email } = data;
    return (
        <div className={styles.item}>
            <FJHeader
                avatarUrl={avatar}
                email={email}
                icon={<LinkedinIcon />}
                platform={SOCIAL_KEY.LINKEDIN}
                defaultAvatar={<DefaultAvatarIcon />}
            />
            <p className={styles.t5} style={{ marginTop: 15, marginBottom: 10 }}>
                {FJLocalStore._('description')}
            </p>
            <div
                style={{ width: '100%', height: 178, position: 'relative', marginBottom: isLackOfDescription ? 18 : 0 }}
            >
                <FJExpansionInput
                    ref={inputDescRef}
                    initValue={isLoadingDescription ? '' : defaultDescription}
                    maxLength={2200}
                    footHeight={40}
                    placeholder={FJLocalStore._('add-video-description')}
                    renderExpansion={_renderDescriptionGenerateButton}
                    onChange={_descriptionChange}
                />
                {isLackOfDescription && <FJErrorTitle />}
                {isLoadingDescription && <FJAITextLoading />}
            </div>
        </div>
    );
};

export default FJLinkedinView;
